import {
    EVENT_NAME_APPLICATION_FORM_CHANGED,
    EVENT_NAME_APPLICATION_FORM_CHANGE_APPROVED,
    EVENT_NAME_APPLICATION_FORM_CHANGE_REJECTED,
    EVENT_NAME_APPLICATION_PREMIUM_SETTING_CHANGED,
    EVENT_NAME_DOCUMENT_RENAMED,
    EVENT_NAME_PAYMENT_ALLOCATION
} from '../constants';

export const getOverviewCommentTitle = (overviewComment) => {
    if(!overviewComment) {
        return  "";
    }

    if(
        overviewComment
        && overviewComment.comment
        && !overviewComment.eventName
        && overviewComment.attachments
        && overviewComment.attachments.length > 0
    ) {
        return "Comment and Document(s) Added";
    }

    if(
        overviewComment
        && !overviewComment.comment
        && !overviewComment.eventName
        && overviewComment.attachments
        && overviewComment.attachments.length > 0
    ) {
        return "Document(s) Added";
    }

    if(
        overviewComment
        && overviewComment.comment
        && !overviewComment.eventName
        && overviewComment.attachments
        && overviewComment.attachments.length === 0
    ) {
        return "Comment Added";
    }

    if(
        overviewComment
        && overviewComment.eventName
        && (
            overviewComment.eventName === EVENT_NAME_APPLICATION_FORM_CHANGE_APPROVED
            || overviewComment.eventName === EVENT_NAME_APPLICATION_FORM_CHANGE_REJECTED
            || overviewComment.eventName === EVENT_NAME_APPLICATION_FORM_CHANGED
            || overviewComment.eventName === EVENT_NAME_APPLICATION_PREMIUM_SETTING_CHANGED
            || overviewComment.eventName === EVENT_NAME_DOCUMENT_RENAMED
            || overviewComment.eventName === EVENT_NAME_PAYMENT_ALLOCATION
        )
    ) {
        return overviewComment.eventName;
    }
};